import { render, staticRenderFns } from "./infoChange.vue?vue&type=template&id=491a9d03&scoped=true"
import script from "./infoChange.vue?vue&type=script&lang=js"
export * from "./infoChange.vue?vue&type=script&lang=js"
import style0 from "./infoChange.vue?vue&type=style&index=0&id=491a9d03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a9d03",
  null
  
)

export default component.exports